<div class="sub-answer__label">
    <label class="sub-answer__labelText" [innerHtml]="subquestion.libelle"> </label>
</div>
<div class="sub-answer__input">
    <input [placeholder]="'global.unit.percent' | i18n" [id]="subquestion.id + '-' + controlId" type="number" [formControl]="myControl" class="textfield textfield--custom" />
</div>
